// Mirrors api/ktp_api/utils/llmPromptText.js so the editor can preview exactly
// what generation will send.

const VARIABLE_RE = /\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g;

const formatRow = (content) => `- ${String(content).split('\n').join('\n  ')}`;

// Same format as the backend: [Otsikko] then "- rivi" lines.
export function assembleRows(rows) {
  const groups = [];
  for (const row of rows) {
    const last = groups[groups.length - 1];
    if (last && last.heading === row.heading) last.lines.push(row.content);
    else groups.push({ heading: row.heading, lines: [row.content] });
  }
  return groups.map(g => `[${g.heading}]\n${g.lines.map(formatRow).join('\n')}`).join('\n\n');
}

export function missingVariables(rows, required) {
  if (!Array.isArray(required) || !required.length) return [];
  const present = new Set();
  for (const row of rows) for (const m of (row.content || '').matchAll(VARIABLE_RE)) present.add(m[1]);
  return required.filter(v => !present.has(v));
}

export function containsVariable(content, required) {
  if (!Array.isArray(required) || !required.length) return false;
  for (const m of (content || '').matchAll(VARIABLE_RE)) if (required.includes(m[1])) return true;
  return false;
}

// Groups consecutive rows under their heading, keeping each row's index in the flat list.
export function groupRows(rows) {
  const groups = [];
  rows.forEach((row, index) => {
    const last = groups[groups.length - 1];
    if (last && last.heading === row.heading) last.rows.push({ row, index });
    else groups.push({ heading: row.heading, rows: [{ row, index }] });
  });
  return groups;
}

let tmpCounter = 0;
export const newRowKey = () => `new-${Date.now()}-${tmpCounter++}`;

// Draft rows carry a stable React key: item_id for saved rows, a temp key for new ones.
export const toDraftRows = (rows) => (rows || []).map(r => ({ key: `item-${r.item_id}`, item_id: r.item_id, heading: r.heading, content: r.content }));

export const draftSignature = (rows, excluded) =>
  JSON.stringify([rows.map(r => [r.item_id ?? null, r.heading, r.content]), [...(excluded || [])].sort((a, b) => a - b)]);
